import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon } from 'semantic-ui-react';
import LoginModalButton from '../LoginModalButton/component';


import './index.css';

const getBackButton = () => (
  <Menu.Item>
    <a href="/">
      <Icon name="arrow left" size="large" className="back-arrow" />
    </a>
  </Menu.Item>
);

const MenuComponent = ({ title }) => (
  <div>
    <Menu borderless size="large">
      {title !== 'Westney Heights Bible Study' && getBackButton()}
      <Menu.Item header className="title">{title}</Menu.Item>
      <Menu.Menu position="right">
        <Menu.Item>
          <LoginModalButton />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  </div>
);

MenuComponent.propTypes = {
  title: PropTypes.string,
};

MenuComponent.defaultProps = {
  title: 'Westney Heights Bible Study',
};

export default MenuComponent;



// WEBPACK FOOTER //
// ./src/modules/Menu/component.js